module.exports = __webpack_public_path__ + "static/account-2.c2c6c0b0.png";